import { abbreviateNumber } from "utils/utils";
const role = localStorage.getItem("role");

export const dashboardCardData = (dashBorardUpperData) => {
  return[
  {
    id: 1,
    title: "Completed Trips",
    subTitle: dashBorardUpperData?.totalfinishedrides || '0',
  },
  {
    id: 2,
    title: "Ongoing Trips",
    subTitle: dashBorardUpperData?.activerides|| '0',
  },
  {
    id: 3,
    title: "Booked Trips",
    subTitle: dashBorardUpperData?.upcomingRides|| '0',
  },
  {
    id: 4,
    title: "Cancelled Trips",
    subTitle: dashBorardUpperData?.canceledRides|| '0',
  },
  {
    id: 5,
    title: "Active Drivers",
    subTitle: dashBorardUpperData?.totalDriver|| '0',
  },
  {
    id: 6,
    title: "Active Sub-Vendors",
    subTitle: dashBorardUpperData?.totalSubVendor|| '0',
  },
  {
    id: 7,
    title: "Companies",
    subTitle: dashBorardUpperData?.company|| '0',
  },
  {
    id: 8,
    title: "Revenue",
    subTitle: '₹ ' + abbreviateNumber(dashBorardUpperData?.earning || 0),
  },
];}

export const updateCompanyDoc = [
  {
    datePicker: true,
    required: true,
    gridSize: 12,
    placeholder: "",
    type: "date",
    name: "chooseDate",
    label: "Contract Date",
  },
  {
    dateRangePicker: true,
    required: true,
    gridSize: 12,
    placeholder: "",
    type: "",
    name: "tenure",
    label: "Tenure",
  },
  {
    fileUpload: true,
    gridSize: 12,
    required: true,
    name: "uploadAgreement",
    label: "Upload Agreement",
    accept: ".pdf,.doc,.docx",
  },
];
